import { createContext, ReactNode } from 'react';
import { StateSetter } from 'types/utils/React';
import { emptyFunction } from 'utils/functions';
import { SharedDocument } from 'types/Document';

export type DeleteModeContextProps = {
  documentsToDelete: SharedDocument[];
  isDeleteMode: boolean;
  setDocumentsToDelete: StateSetter<SharedDocument[]>;
  setIsDeleteMode: StateSetter<boolean>;
};

const initialState = {
  documentsToDelete: [],
  isDeleteMode: false,
  setDocumentsToDelete: emptyFunction,
  setIsDeleteMode: emptyFunction,
};

const deleteModeContext = createContext<DeleteModeContextProps>(initialState),
  { Provider } = deleteModeContext;

type DeleteModeContextProviderProps = {
  children: ReactNode;
  documentsToDelete: SharedDocument[];
  isDeleteMode: boolean;
  setDocumentsToDelete: StateSetter<SharedDocument[]>;
  setIsDeleteMode: StateSetter<boolean>;
};

const DeleteModeContextProvider = ({
  children,
  documentsToDelete,
  isDeleteMode,
  setDocumentsToDelete,
  setIsDeleteMode,
}: DeleteModeContextProviderProps): JSX.Element => (
  <Provider
    value={{
      documentsToDelete,
      isDeleteMode,
      setDocumentsToDelete,
      setIsDeleteMode,
    }}
  >
    {children}
  </Provider>
);

export { deleteModeContext, DeleteModeContextProvider };
